/**
 * ContextStatsLine — compact "N tokens · P% used · $X spent" line
 * (plan agent-todo-context-panel §A.1, OpenCode Context block analog).
 *
 * INV-8 / CON-3: each segment renders only when its datum exists; the line
 * disappears entirely when none do. No placeholder values, ever.
 */
import type { JSX } from "react";
import { formatCost, formatTokens } from "./formatStats";

export function ContextStatsLine({
  tokens,
  percent,
  costMicros,
}: {
  readonly tokens: number | null;
  readonly percent: number | null;
  readonly costMicros: number | null;
}): JSX.Element | null {
  const segments: string[] = [];
  if (tokens !== null) segments.push(`${formatTokens(tokens)} tokens`);
  if (percent !== null) segments.push(`${String(percent)}% used`);
  if (costMicros !== null) segments.push(`${formatCost(costMicros)} spent`);
  if (segments.length === 0) return null;
  // Owner decision 2026-07-23: a LONE zero cost (zero-rate subscription,
  // no live tokens yet) carries no information — hide the line until
  // there is something real to show.
  if (tokens === null && percent === null && costMicros === 0) return null;

  return (
    <div className="mx-4 mb-2 flex items-center gap-2 px-3.5 text-xs text-[var(--color-agent-center-text-muted)]">
      <span className="font-semibold">Context</span>
      <span>{segments.join(" · ")}</span>
    </div>
  );
}
